export { default as Emails } from './Emails.png';
export { default as Digitals } from './Digitals.png';
export { default as Mobile } from './Mobile.png';
export { default as OnlineMenuDesigner } from './OnlineMenuDesigner.png';
export { default as OnlineOrdering } from './OnlineOrdering.png';
export { default as POS } from './POS.png';
export { default as Websites } from './Websites.png';
export { default as K12 } from './K12.png';



// WEBPACK FOOTER //
// ./src/common/Resources/Images/ApplyCycleMenu/index.js